import { useMemo, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { getDefaultValuesObj, getRemoveOnClickBtnFunc } from "./lib";
import { MappingItemForm as UI } from "./ui/MappingItemForm";
import { api } from "../../../api";
import { toastMessageConfig } from "../../../../entities/toastMessageConfig";

export const MappingItemForm = ({
  scopeStringId,
  mappingFieldsObj,
  toastRef,
  parentComponentState,
}) => {
  const defaultValuesObj = useMemo(() => getDefaultValuesObj(mappingFieldsObj));

  const componentState = useState({
    status: "waiting",
  });

  const [componentStateValue, setComponentStateValue] = componentState;
  const formState = useForm({
    mode: "onChange",
    defaultValues: defaultValuesObj,
  });

  const bitrix24FieldsOptionsStateRef = useRef(null);
  const optimaFieldsOptionsStateRef = useRef(null);

  const onSubmit = async () => {
    setComponentStateValue({ status: "loading" });

    const requestBodyObj = {
      bitrixField:
        bitrix24FieldsOptionsStateRef.current[0].selectedOptionGroup.items[0],
      optimaField:
        optimaFieldsOptionsStateRef.current[0].selectedOptionGroup.items[0],
    };

    const mappingActionItemResponse = mappingFieldsObj?.isNew
      ? await api.mappingFields.post(scopeStringId, requestBodyObj)
      : await api.mappingFields.put(mappingFieldsObj.id, requestBodyObj);

    setComponentStateValue({ status: "waiting" });

    const { warning, error } = mappingActionItemResponse;

    if (warning) {
      toastRef.current.show({
        severity: "warn",
        summary: warning.title,
        detail: warning.message,
        life: toastMessageConfig.life,
      });
      return;
    }
    if (error) {
      toastRef.current.show({
        severity: "error",
        summary: error.title,
        detail: error.message,
        sticky: true,
      });
      return;
    }

    toastRef.current.show({
      severity: "success",
      summary: "Powodzenie",
      detail: "Operacja się udała",
      life: toastMessageConfig.life,
    });

    if (mappingFieldsObj?.isNew) {
      const [, setParentComponentStateValue] = parentComponentState;
      setParentComponentStateValue((prevState) => ({
        ...prevState,
        refreshesNumber: prevState.refreshesNumber + 1,
      }));
    }
  };

  if (componentStateValue.status === "loading")
    return (
      <UI
        scopeStringId={scopeStringId}
        formState={formState}
        onSubmit={onSubmit}
        onRemove={getRemoveOnClickBtnFunc(
          componentState,
          mappingFieldsObj,
          toastRef,
          parentComponentState
        )}
        toastRef={toastRef}
        mappingFieldsObj={mappingFieldsObj}
        bitrix24FieldsOptionsStateRef={bitrix24FieldsOptionsStateRef}
        optimaFieldsOptionsStateRef={optimaFieldsOptionsStateRef}
        loading
      />
    );

  if (componentStateValue.status === "waiting")
    return (
      <UI
        scopeStringId={scopeStringId}
        formState={formState}
        onSubmit={onSubmit}
        onRemove={getRemoveOnClickBtnFunc(
          componentState,
          mappingFieldsObj,
          toastRef,
          parentComponentState
        )}
        toastRef={toastRef}
        mappingFieldsObj={mappingFieldsObj}
        bitrix24FieldsOptionsStateRef={bitrix24FieldsOptionsStateRef}
        optimaFieldsOptionsStateRef={optimaFieldsOptionsStateRef}
      />
    );
};
